import { VehicletypeEnum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { VehicleCategoryEntity } from "../vehicle-category/vehicle-category.entity";

@Entity('vehicle_model')

export class VehicleModelEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id"
    })
    id: number

    @Column('varchar', {
        name: 'vehicle_model',
        nullable: true
    })
    vehicleModel: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @ManyToOne(() => VehicleCategoryEntity, dpom => dpom.vehicleCategory)
    @JoinColumn({ name: 'vehicle_category' })
    vehicleCategory: VehicleCategoryEntity;

}